import { render } from "./PaymentView.vue?vue&type=template&id=55d5e6f0"
import script from "./PaymentView.vue?vue&type=script&lang=js"
export * from "./PaymentView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__